import ConsoleError from '@/modules/core/models/errors/ConsoleError'
import Joi from 'joi'

export default Joi.object({
  businessLine: Joi.string().required(),
  businessLineId: Joi.string().required(),
  maxInsurances: Joi.number().integer().min(0).required(),
  maxDays: Joi.number().integer().min(0).required(),
  isPymes: Joi.boolean().optional(),
  hiringMaxAges: Joi.object({
    holderInsured: Joi.object({
      min: Joi.string().required(),
      max: Joi.string().required()
    }).required(),
    holderNotInsured: Joi.object({
      min: Joi.string().required(),
      max: Joi.string().required()
    }).required(),
    insured: Joi.object({
      min: Joi.string().required(),
      max: Joi.string().required()
    }).required()
  }).required(),
  hiringMaxAgesInternationalWork: Joi.object({
    holderInsured: Joi.object({
      min: Joi.string().required(),
      max: Joi.string().required()
    }).required(),
    holderNotInsured: Joi.object({
      min: Joi.string().required(),
      max: Joi.string().required()
    }).required(),
    insured: Joi.object({
      min: Joi.string().required(),
      max: Joi.string().required()
    }).required()
  }).optional(),
  hiringMaxAgesInternationalStudy: Joi.object({
    holderInsured: Joi.object({
      min: Joi.string().required(),
      max: Joi.string().required()
    }).required(),
    holderNotInsured: Joi.object({
      min: Joi.string().required(),
      max: Joi.string().required()
    }).required(),
    insured: Joi.object({
      min: Joi.string().required(),
      max: Joi.string().required()
    }).required()
  }).optional(),
  defaultHiringMaxAges: Joi.object({
    holderInsured: Joi.object({
      min: Joi.string().required(),
      max: Joi.string().required()
    }).required(),
    holderNotInsured: Joi.object({
      min: Joi.string().required(),
      max: Joi.string().required()
    }).required(),
    insured: Joi.object({
      min: Joi.string().required(),
      max: Joi.string().required()
    }).required()
  }).required(),
  stayAbroadTypes: Joi.object({
    work: Joi.object({
      id: Joi.string().required(),
      text: Joi.string().required(),
      default: Joi.boolean().required()
    }).required(),
    study: Joi.object({
      id: Joi.string().required(),
      text: Joi.string().required(),
      default: Joi.boolean().required()
    }).required()
  }).optional(),
  billingCycles: Joi.object({
    monthly: Joi.object({
      id: Joi.string().required(),
      textInFilter: Joi.string().required(),
      textInPrice: Joi.string().required(),
      discountText: Joi.string().allow(''),
      default: Joi.boolean().required()
    }).required(),
    quarterly: Joi.object({
      id: Joi.string().required(),
      textInFilter: Joi.string().required(),
      textInPrice: Joi.string().required(),
      discountText: Joi.string().allow(''),
      default: Joi.boolean().required()
    }).required(),
    semiannual: Joi.object({
      id: Joi.string().required(),
      textInFilter: Joi.string().required(),
      textInPrice: Joi.string().required(),
      discountText: Joi.string().allow(''),
      default: Joi.boolean().required()
    }).required(),
    annual: Joi.object({
      id: Joi.string().required(),
      textInFilter: Joi.string().required(),
      textInPrice: Joi.string().required(),
      discountText: Joi.string().allow(''),
      default: Joi.boolean().required()
    }).required()
  }).required(),
  houseTypes: Joi.object({
    apartment: Joi.object({
      id: Joi.string().required(),
      text: Joi.string().required(),
      default: Joi.boolean().required()
    }).required(),
    house: Joi.object({
      id: Joi.string().required(),
      text: Joi.string().required(),
      default: Joi.boolean().required()
    }).required()
  }).optional(),
  relationships: Joi.any().allow(null),
  copaymentTypes: Joi.object({
    high: Joi.object({
      id: Joi.string().required(),
      text: Joi.string().required(),
      default: Joi.boolean().required()
    }).optional(),
    low: Joi.object({
      id: Joi.string().required(),
      text: Joi.string().required(),
      default: Joi.boolean().required()
    }).optional(),
    withCopayment: Joi.object({
      id: Joi.string().required(),
      text: Joi.string().required(),
      default: Joi.boolean().required()
    }).optional(),
    noCopayment: Joi.object({
      id: Joi.string().required(),
      text: Joi.string().required(),
      default: Joi.boolean().required()
    }).required(),
    none: Joi.object({
      id: Joi.string().required(),
      text: Joi.string().required(),
      default: Joi.boolean().required()
    }).required()
  }).required(),
  insuranceTypes: Joi.object({
    health: Joi.object({
      id: Joi.string().required(),
      text: Joi.string().required(),
      disabled: Joi.boolean().required(),
      default: Joi.boolean().required()
    }).required(),
    reimbursement: Joi.object({
      id: Joi.string().required(),
      text: Joi.string().required(),
      disabled: Joi.boolean().required(),
      default: Joi.boolean().required()
    }).required(),
    abroad: Joi.object({
      id: Joi.string().required(),
      text: Joi.string().required(),
      disabled: Joi.boolean().required(),
      default: Joi.boolean().required()
    }).optional()
  }).required(),
  genders: Joi.object({
    female: Joi.object({
      id: Joi.string().required(),
      text: Joi.string().required(),
      default: Joi.boolean().required()
    }).required(),
    male: Joi.object({
      id: Joi.string().required(),
      text: Joi.string().required(),
      default: Joi.boolean().required()
    }).required()
  }).required(),
  tags: Joi.object({
    'common-gdpr': Joi.object({
      'common-gdpr-intro': Joi.object({
        label: Joi.string().required(),
        icon: Joi.string().required()
      }).required()
    }).required(),
    'health-pricing': Joi.object({
      'health-pricing-copay': Joi.object({
        label: Joi.string().required(),
        icon: Joi.string().required()
      }).required(),
      'health-pricing-startdate': Joi.object({
        label: Joi.string().required(),
        icon: Joi.string().required()
      }).required()
    }).required(),
    'health-contracting': Joi.object({
      'health-contracting-another': Joi.object({
        label: Joi.string().required(),
        icon: Joi.string().required()
      }).required(),
      'health-contracting-another-company-insured': Joi.object({
        label: Joi.string().required(),
        icon: Joi.string().required()
      }).required(),
      'health-contracting-identification': Joi.object({
        label: Joi.string().required(),
        icon: Joi.string().required()
      }).required(),
      'health-contracting-personal-data': Joi.object({
        label: Joi.string().required(),
        icon: Joi.string().required()
      }).required(),
      'health-contracting-personal-data-insured': Joi.object({
        label: Joi.string().required(),
        icon: Joi.string().required()
      }).required(),
      'health-contracting-personal-data-2': Joi.object({
        label: Joi.string().required(),
        icon: Joi.string().required()
      }).required(),
      'health-contracting-contact-insured': Joi.object({
        label: Joi.string().required(),
        icon: Joi.string().required()
      }).required(),
      'health-contracting-bank': Joi.object({
        label: Joi.string().required(),
        icon: Joi.string().required()
      }).required(),
      'health-international-contracting-another': Joi.object({
        label: Joi.string().required(),
        icon: Joi.string().required()
      }).required(),
      'health-international-contracting-another-company-insured': Joi.object({
        label: Joi.string().required(),
        icon: Joi.string().required()
      }).required()
    }).optional()
  })
    .required()
    .error((errors) => {
      const text = `DXP Health branch configuration - ${errors
        .map((e) => `"${e.local.label}" is required`)
        .join()}`
      return new ConsoleError({ message: text })
    })
    .unknown(true)
})
